/* global angular */
angular.module('ua5App.index.about')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('index.about.website', {
                url: '/website',
                templateUrl: 'states/index.about/index.about.website/index.about.website.html',
                controller: 'AboutWebsiteCtrl',
                controllerAs: 'ctrl',
                resolve: {
                    // Posts Resolve Here //
                    data: ['AboutWebsiteResource', function(AboutWebsiteResource) {
                        return AboutWebsiteResource.get().$promise;
                    }]
                }
            })
        ;
    }])
    .factory('AboutWebsiteResource', ['$resource', '$rootScope', function($resource, $rootScope) {
        var url = 'api/wp-json/pages/website';
        if ($rootScope.dev) {
            url = url + '?time=' + Date.now();
        }
        return $resource(url, {}, {
            get: {
                method: 'GET',
                cache: true
            }
        });
    }])
    .controller('AboutWebsiteCtrl', ['MetaFactory', 'data', function(MetaFactory, data) {

        MetaFactory.set({
            title: data.title + ' | Storylines: Contemporary Art at the Guggenheim',
            ogTitle: data.title + ' | Storylines: Contemporary Art at the Guggenheim'
        });
        this.data = data;
    }])
;
